module.exports = __webpack_public_path__ + "00_hair.0f5669fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/00_hair.png
// module id = nijJ
// module chunks = 0